<template>
  <div class="icon-container">
    <img :src="asset_path(`/images/icons/${name}`)" :alt="name" class="icon-image" />
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
